import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import SettingsView from './settings.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useSettingsRoutes = () => (
  <Route
    path={pages.settings.path}
    element={
      <ProtectedRoute module="settings" checkAnySubmodule>
        <SettingsView />
      </ProtectedRoute>
    }
  >
    <Route
      index
      element={
        <ProtectedRoute module="settings" checkAnySubmodule>
          <SettingsView />
        </ProtectedRoute>
      }
    />
    <Route
      path={pages.settings.path + '/:settingsSubRouteId'}
      element={
        <ProtectedRoute module="settings" checkAnySubmodule>
          <SettingsView />
        </ProtectedRoute>
      }
    />
  </Route>
);

export default useSettingsRoutes;
